import React from 'react';
import styled from 'styled-components';
import { useCloudSecurity } from '../context/CloudSecurityContext';
import Category from './Category';
import FrameworkFilter from './FrameworkFilter';

const Container = styled.div`
  display: ${props => props.visible ? 'block' : 'none'};
  animation: fadeIn 0.5s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #8892b0;
  margin-bottom: 30px;
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const ViewResultsButton = styled.button`
  padding: 15px 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(102, 126, 234, 0.5);
  }
`;

const Assessment = () => {
  const { 
    currentProvider, 
    assessmentsData,
    setShowResults,
    selectedFramework
  } = useCloudSecurity();
  
  const assessment = currentProvider ? assessmentsData[currentProvider] : null;
  
  if (!assessment) {
    return null;
  }
  
  return (
    <Container visible={currentProvider !== null}>
      <Title>🔍 {assessment.name} Security Assessment</Title>
      <Subtitle>
        Aligned with CSA CCM v4, NIST CSF 2.0, ISO 27001:2022, CIS Controls v8, SOC 2, PCI DSS v4.0, DORA, and NIS2
      </Subtitle>
      
      <FrameworkFilter />
      
      {assessment.categories.map((category, index) => (
        <Category
          key={index}
          category={category}
          catIndex={index}
          selectedFramework={selectedFramework}
        />
      ))}
      
      <ButtonContainer>
        <ViewResultsButton onClick={() => setShowResults(true)}>
          📊 View Security Assessment Results
        </ViewResultsButton>
      </ButtonContainer>
    </Container>
  );
};

export default Assessment; 